import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import twitterWidgetComponent from './app';
import './styles.scss';

export default class twitterWidgetModule {
    constructor(config, $twitterWidgets) {
        let props = {
        	account : config.accountName,
            limitNumber : this.getLimitNumbers(config.limitTweetsNumbers),
        }
        $twitterWidgets.each((index, el) => {
            ReactDOM.render(React.createElement(twitterWidgetComponent, props), el);
        }) 
    }
    getLimitNumbers(limitNumber){
            if (limitNumber ===undefined){
                return "7";
             }
             return limitNumber;
         }

}
twitterWidgetModule.selector = '[data-module="Twitter"]';
twitterWidgetModule.init = function(config, $modules) {
    $modules = $modules || $(twitterWidgetModule.selector);
    if ($modules.length > 0) {
        new twitterWidgetModule(config, $modules);
    }
}



// WEBPACK FOOTER //
// ./medscape_modules/twitter-widget/index.js